/**
 * Add connection header component save, update and delete connection header to database as well upload connection header image to s3 bucket.
 */

import React from "react";
import { connect } from "react-redux";
import { DialogBox } from "../../../common/dialogbox";
import { BackStrip, Header } from "../../../common/layout";
import { bindActionCreators } from "redux";
import DatePicker from "react-datepicker";
import * as postsActions from "../../../store/admin";
import * as _ from "lodash";
import { config } from "../../../config/config";
import { NotificationManager } from "react-notifications";
import { NavLink } from "react-router-dom";
import * as moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-datepicker/dist/react-datepicker.css";
import "react-notifications/lib/notifications.css";
import { deviceDetect } from "react-device-detect";
import { utilService } from "../../../common/utils";

class AddConnectionHeader extends React.Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onFeaturedImgchange = this.onFeaturedImgchange.bind(this);
    // this.onDeletePost = this.onDeletePost.bind(this);
    this.actionsButtonFormatter = this.actionsButtonFormatter.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      modal_data: {
        show: false,
      },
      postData: {
        publish_start: new Date(),
        publish_end: new Date(),
        caption_location: "top_left",
        alttext: ''
      },
      featuredImgFileObj: null,
      featuredImgUrl: "",
      featuredImgBase64Url: "",
      errors: {},
      connectionheaderUid: "",
      isLoading: false,
      isSaving: false,
      isdeleteing: false,
    };
  }
  /**
   * It is a react lifycycle method which is invoked immediately after a component is mounted
   */
  componentDidMount() {
    // google analytic page view
    utilService.pageView();
    // save page visit logs to dynamodb
    let device = deviceDetect();
    let osName = utilService.getOsName(device);
    let browserName = utilService.getBrowserName(device);
    let pageLogsData = {
      ipstack_access_key: config.ipstack_access_key,
      pageId: "add-newsletter-header",
      title: "Add Newletter Header",
      browserName: browserName,
      osName: osName,
      pageType: "Add Newletter Header Page",
      visited_at: new Date(),
      country_name: this.props.user.country_name,
      users_userid: this.props.user.userUid,
      users_username: this.props.user.username,
      users_firstname: this.props.user.firstname,
      users_lastname: this.props.user.surname,
    };
    // save page logs
    this.props.savePageVisitLogs({
      token: this.props.token,
      data: pageLogsData,
    });
    this.props.fetchConnectionHeaders({
      token: this.props.token,
      id: "",
    });
  }
  /**
   * It is a method which is invoked after a component is instantiated as well as
   * when it receives new props
   * @param {*} nextProps : Getting new props from reducer
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.connHeaders !== nextProps.connHeaders) {
      if (
        nextProps.connHeaders &&
        nextProps.connHeaders.length > 0 &&
        this.state.connectionheaderUid
      ) {
        let connection_header_json = _.find(nextProps.connHeaders, {
          connectionheaderUid: this.state.connectionheaderUid,
        });
        if (connection_header_json) {
          connection_header_json["publish_start"] = new Date(
            connection_header_json["publish_start"]
          );
          connection_header_json["publish_end"] = new Date(
            connection_header_json["publish_end"]
          );
          this.setState({
            ...this.state,
            postData: connection_header_json,
            featuredImgUrl: connection_header_json.featured_img_url,
          });
        }
      }
    }
  }

  /**
   * It is a react lifycycle method which is invoked immediately after updating occurs.
   * @param {*} prevProps Getting previous props
   * @param {*} prevState Getting previous state
   */
  componentDidUpdate(prevProps, prevState) {
    // console.log('prev state...', prevState)
    if (prevProps.connActionLoading && !this.props.connActionLoading) {
      if (prevState.isdeleteing) {
        this.setState(
          {
            isLoading: false,
            isdeleteing: false,
          },
          function () {
            NotificationManager.success(
              "Success message",
              "Deleted successfully."
            );
          }
        );
      }

      if (prevState.isSaving) {
        this.setState(
          {
            postData: {
              publish_start: new Date(),
              publish_end: new Date(),
              caption_location: "top_left",
            },
            featuredImgFileObj: null,
            featuredImgUrl: "",
            featuredImgBase64Url: "",
            errors: {},
            isLoading: false,
            isSaving: false,
            isdeleteing: false,
          },
          function () {
            NotificationManager.success(
              "Success message",
              "Saved successfully."
            );
          }
        );
      }
    }
  }
  handleInputChange(e) {
    const { name, value } = e.target;
    // console.log(name, value)
    let fields = this.state.postData;
    if ( value === 'no_caption'){
      fields['caption'] = null
    }
    fields[name] = value;
    if ( value === 'no_caption'){
      fields['caption'] = null
    }
    this.setState({
      fields,
    });
  }
  onFeaturedImgchange(e) {
    if (e.target.files[0]) {
      // console.log(e.target.files[0])
      let fields = this.state.postData;
      let url = this.getBase64Image(e.target.files[0]);
      url.then((result) => {
        // console.log('result....', result)
        fields["featuredImage"] = result;
        fields["featured_img_type"] = "jpeg";
        fields["featured_img_url"] = "";
      });
      this.setState({
        fields,
        featuredImgUrl: URL.createObjectURL(e.target.files[0]),
        featuredImgFileObj: e.target.files[0],
      });
    }
  }
  getBase64Image(file) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        // console.log(reader.result);
        resolve(reader.result.split(",")[1]);
        // return reader.result
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
        reject("");
      };
    });
  }

  onEditPost(cell, row, rowIndex) {
    this.setState(
      {
        connectionheaderUid: row.connectionheaderUid,
      },
      function () {
        this.props.fetchConnectionHeaders({
          token: this.props.token,
        });
      }
    );
  }

  /**
   * Delete header based on connectionheaderUid
   * @param {*} cell table cell data
   * @param {*} row  table row data
   * @param {*} rowIndex table row index
   */
  onDeletePost(cell, row, rowIndex) {
    const id = row.connectionheaderUid;
    if (id) {
      this.setState({
        ...this.state,
        modal_data: {
          ...this.state.modal_data,
          show: true,
          data: {
            heading: "Delete Header",
            body: "Are you sure you want to permanetly remove this header ?",
            rowId: id,
          },
        },
      });
    }
  }

  handleCloseModal() {
    this.setState({
      ...this.state,
      modal_data: {
        ...this.state.modal_data,
        show: false,
      },
    });
  }

  OnDialogSubmit(id) {
    this.setState(
      {
        ...this.state,
        modal_data: {
          ...this.state.modal_data,
          show: false,
        },
        isLoading: true,
        isdeleteing: true,
      },
      function () {
        this.props.deleteConnectionHeader({
          id: id,
          token: this.props.token,
        });
      }
    );
  }

  handleDateChange(date, name) {
    // console.log(date)
    // console.log(this.state)
    let fields = this.state.postData;
    fields[name] = date;
    this.setState({
      fields,
    });
  }

  actionsButtonFormatter(cell, row, enumObject, rowIndex) {
    // console.log(cell)
    // console.log(row)
    // console.log(enumObject)
    // console.log(rowIndex)
    return (
      <div className="d-flex align-items-center nav-con">
        <button
          type="button"
          className="bg-dark filter-btn"
          onClick={this.onEditPost.bind(this, cell, row, rowIndex)}
        >
          <i className="fa fa-pencil" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          className="bg-primary filter-btn"
          onClick={this.onDeletePost.bind(this, cell, row, rowIndex)}
        >
          <i className="fa fa-trash" aria-hidden="true"></i>
        </button>
      </div>
    );
  }

  onCancel(e) {
    e.preventDefault();
    this.props.history.push("/admin");
  }

  validateForm() {
    let fields = this.state.postData;
    let errors = {};
    let formIsValid = true;

    if (!this.state.postData.caption_location === 'no_caption' && !fields['caption']) {
      formIsValid = false;
      errors["caption"] = "*Please enter caption.";
    }
    if (!fields["publish_start"] || fields["publish_start"] === null) {
      formIsValid = false;
      errors["publish_start"] = "*Please select start date.";
    }
    if (!fields["publish_end"] || fields["publish_end"] === null) {
      formIsValid = false;
      errors["publish_end"] = "*Please select end date.";
    }
    if (fields["publish_end"] < fields["publish_start"]) {
      formIsValid = false;
      errors["publish_end"] = "*Please select valid date.";
    }
    if (!this.state.featuredImgUrl && !fields["featuredImage"]) {
      formIsValid = false;
      errors["featuredImage"] = "*Please select image.";
    }
    this.setState({
      errors: errors,
    });
    return formIsValid;
  }

  onSubmit(e) {
    e.preventDefault();
    if (this.validateForm()) {
      // console.log(this.state)
      if (this.state.postData.connectionheaderUid) {
        // console.log(this.state.postData)
        let fields = this.state.postData;
        fields["featured_img_url"] = fields["connectionheaderUid"];
        fields["updated_at"] = new Date();
        this.setState(
          {
            fields,
            isLoading: true,
            isSaving: true,
          },
          () => {
            this.props.updateConnectionHeader({
              token: this.props.token,
              data: this.state.postData,
            });
          }
        );
      } else {
        let fields = this.state.postData;
        fields["created_at"] = new Date();
        fields["updated_at"] = new Date();
        fields["users_userid"] = this.props.user.userUid;
        fields["users_username"] = this.props.user.username;
        fields["users_firstname"] = this.props.user.firstname;
        fields["users_lastname"] = this.props.user.surname;
        this.setState({
          fields,
          isLoading: true,
          isSaving: true,
        });
        // console.log(this.state.postData)
        this.props.saveConnectionHeader({
          token: this.props.token,
          data: this.state.postData,
        });
      }
    }
  }
  /**
   * render() is a react lifecycle method.
   * It uses jsx and returns jsx with backend data.
   */
  render() {
    const { connHeaders } = this.props;
    // console.log(this.state.postData)
    const columns = [
      {
        dataField: "publish_start",
        text: "Publish Start",
        formatter: dateFormatter,
        sort: true,
      },
      {
        dataField: "publish_end",
        text: "Publish End",
        formatter: dateFormatter,
        sort: true,
      },
      {
        dataField: "caption",
        text: "Caption",
        sort: true,
      },
      {
        dataField: "caption_location",
        text: "Caption Location",
        sort: true,
      },
      {
        dataField: "created_at",
        text: "Created At",
        formatter: dateFormatter,
        sort: true,
      },
      {
        dataField: "connectionheaderUid",
        text: "Currently Live",
        formatter: livenowFormatter,
        sort: true,
      },
      {
        dataField: "button",
        text: "Actions",
        formatter: this.actionsButtonFormatter,
      },
    ];
    const defaultSorted = [
      {
        dataField: "created_at",
        order: "desc",
      },
    ];

    const postList = connHeaders && (
      <div className="postsTable">
        <BootstrapTable
          bootstrap4
          keyField="connectionheaderUid"
          data={connHeaders}
          loading={true}
          columns={columns}
          defaultSorted={defaultSorted}
          pagination={paginationFactory()}
          noDataIndication={indication}
        />
      </div>
    );

    return (
      <div>
        <BackStrip nav="/admin" isFilter="false" />
        <div className="position-relative">
          <div id="content">
            <Header cname="admin-home" text="Add Newsletter Header" />
            <main className="connections-header">
              <div className="container" style={{ maxWidth: "95%" }}>
                <form
                  name="conheaderForm"
                  onSubmit={this.onSubmit}
                  ref={(el) => (this.myFormRef = el)}
                >
                  <div className="row justify-content-end brd-btm">
                    <ul
                      className="nav nav-pills d-flex justify-content-center"
                      role="tablist"
                    >
                      <li className="nav-item">
                        <NavLink className="nav-link active" to="/admin">
                          Admin Home
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink
                          className="nav-link"
                          data-toggle="pill"
                          to="/admin/email-logs"
                        >
                          Email Logs
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-toggle="pill"
                          href="#archived"
                        >
                          Web Logs
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="connection-wraps">
                    <div className="brd-1">
                      <div className="row justify-content-center pt-3">
                        <div className="col-md-5">
                          <div className="date pb-2">
                            <p className="datetext">From Date</p>
                            <DatePicker
                              className="form-control"
                              showTimeSelect
                              timeFormat="HH:mm"
                              timeCaption="time"
                              dateFormat="MMMM d, yyyy h:mm aa"
                              minDate={new Date()}
                              selected={this.state.postData.publish_start}
                              onChange={(date) =>
                                this.handleDateChange(date, "publish_start")
                              }
                            />
                            <div className="errorMsg">
                              {this.state.errors["publish_start"]}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-5">
                          <div className="date pb-2">
                            <p className="datetext">To Date</p>
                            <DatePicker
                              className="form-control"
                              showTimeSelect
                              timeFormat="HH:mm"
                              timeCaption="time"
                              dateFormat="MMMM d, yyyy h:mm aa"
                              minDate={this.state.postData.publish_start}
                              selected={this.state.postData.publish_end}
                              onChange={(date) =>
                                this.handleDateChange(date, "publish_end")
                              }
                            />
                            <div className="errorMsg">
                              {this.state.errors["publish_end"]}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-10 pt-3">
                          <div className="">
                            <p className="datetext">Alt text</p>
                            <input
                              type="text"
                              name="alttext"
                              className="form-control"
                              onChange={this.handleInputChange}
                              value={this.state.postData.alttext || ''}
                            />
                            <div className="errorMsg">
                              {this.state.errors['alttext']}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-10 pt-3">
                          <div className="">
                            <p className="datetext">Caption</p>
                            <input
                              type="text"
                              readOnly={this.state.postData.caption_location === 'no_caption'}
                              name="caption"
                              className="form-control"
                              onChange={this.handleInputChange}
                              value={this.state.postData.caption || ""}
                            />
                            <div className="errorMsg">
                              {this.state.errors["caption"]}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row justify-content-center pt-3">
                        <div className="col-md-10">
                          <div></div>
                          <div className="row pt-1">
                            <div className="col-3">
                              <p className="datetext">Caption Location</p>
                            </div>
                            <div className="col-8">
                              <div className="row">
                                <div className="col-md-5 col-lg-6">
                                  <label className="typeradio">
                                    Top Left
                                    <br />
                                    <input
                                      type="radio"
                                      checked={
                                        this.state.postData.caption_location ===
                                        "top_left"
                                      }
                                      name="caption_location"
                                      onChange={this.handleInputChange}
                                      value="top_left"
                                    />
                                    <span className="radiomark"></span>
                                  </label>
                                </div>
                                <div className="col-md-5 col-lg-6">
                                  <label className="typeradio">
                                    Top Right
                                    <br />
                                    <input
                                      type="radio"
                                      checked={
                                        this.state.postData.caption_location ===
                                        "top_right"
                                      }
                                      onChange={this.handleInputChange}
                                      name="caption_location"
                                      value="top_right"
                                    />
                                    <span className="radiomark"></span>
                                  </label>
                                </div>
                                <div className="col-md-5 col-lg-6 pt-1">
                                  <label className="typeradio">
                                    Bottom Left
                                    <br />
                                    <input
                                      type="radio"
                                      checked={
                                        this.state.postData.caption_location ===
                                        "bottom_left"
                                      }
                                      onChange={this.handleInputChange}
                                      name="caption_location"
                                      value="bottom_left"
                                    />
                                    <span className="radiomark"></span>
                                  </label>
                                </div>
                                <div className="col-md-5 col-lg-6 pt-1">
                                  <label className="typeradio">
                                    Bottom Right
                                    <br />
                                    <input
                                      type="radio"
                                      checked={
                                        this.state.postData.caption_location ===
                                        "bottom_right"
                                      }
                                      name="caption_location"
                                      value="bottom_right"
                                      onChange={this.handleInputChange}
                                    />
                                    <span className="radiomark"></span>
                                  </label>
                                </div>
                                <div className="col-md-5 col-lg-6 pt-1">
                                  <label className="typeradio">
                                    No Caption
                                    <br />
                                    <input
                                      type="radio"
                                      checked={
                                        this.state.postData.caption_location ===
                                        "no_caption"
                                      }
                                      name="caption_location"
                                      value="no_caption"
                                      onChange={this.handleInputChange}
                                    />
                                    <span className="radiomark"></span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-md-6">
                          <div className="priview"></div>
                          <div className="d-flex align-items-center flex-md-column flex-xl-row">
                            <input
                              type="file"
                              id="myFile"
                              className="custom-file-input"
                              onChange={this.onFeaturedImgchange}
                            />
                            <p>
                              Hero Image
                              <br /> (1600*690)
                            </p>
                          </div>
                          <div className="errorMsg offset-lg-2">
                            {this.state.errors["featuredImage"]}
                          </div>
                        </div>
                        <div className="col-md-12 pt-1">
                          {/* <img src="assets/images/current.png" alt="PLC Farewell" title="plc farewell" className="img-fluid" /> */}
                          {this.state.featuredImgUrl && (
                            <div className="img-fluid text-center">
                              <img
                                src={this.state.featuredImgUrl}
                                width="800px"
                                height="343px"
                                alt="Preview"
                                className="img-fluid"
                              ></img>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end pt-3 col-md-10 pb-5">
                    {this.state.isSaving ? (
                      <a href="#">
                        <button className="bg-primary filter-btn">
                          Save ...
                        </button>
                      </a>
                    ) : (
                      <a href="#">
                        <button className="bg-primary filter-btn">Save</button>
                      </a>
                    )}
                    <button
                      className="bg-dark filter-btn"
                      onClick={this.onCancel.bind(this)}
                    >
                      cancel
                    </button>
                  </div>
                </form>
                {this.props.connActionLoading === true && (
                  <utilService.GridSweetLoader
                    loading={this.props.connActionLoading}
                  />
                )}
                {postList}
              </div>
              <DialogBox
                show_modal={this.state.modal_data}
                hide_modal={this.handleCloseModal.bind(this)}
                onSubmit={this.OnDialogSubmit.bind(this)}
              />
            </main>
          </div>
        </div>
      </div>
    );
  }
}

function dateFormatter(cell, row) {
  if (cell === "UNPUBLISHED" || cell === "INDEFINITE") {
    return cell;
  } else {
    // return new Date(cell).toLocaleString()
    return moment(cell).format("YYYY-MM-DD hh:mm a");
  }
}

function captionLocationFormatter(cell, row) {}

function livenowFormatter(cell, row) {
  // console.log(row)
  if (cell) {
    if (
      new Date(row.publish_start) <= new Date() &&
      new Date(row.publish_end) >= new Date()
    ) {
      return "Yes";
    } else {
      return "No";
    }
  } else {
    return "No";
  }
}

/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 * @param {*} props : Getting props of this component
 */
function mapStateToProps(state, props) {
  // console.log('state....', state)
  return {
    connActionLoading: state.connHeader.actionsloading,
    token: state.user.cognito_data.token,
    user: state.user.user,
    connHeaders: Object.values(state.connHeader.byId),
  };
}

function indication() {
  return "No records found!";
}

/**
 * connect() function connects a react component to a redux store.
 */
export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(postsActions, dispatch)
)(AddConnectionHeader);
